import React, { Fragment } from "react";
import Loader from "./Loader";

const FeeDetailsLoader = () => (
  <Fragment>
    {/* card for registered courses display  */}
    <div className="row no-gutters">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-header">
            <div className="row no-gutters">
              <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 p-2">
                Make Payment
              </div>
            </div>
          </div>
          <div className="card-body p-0">
            <div className="row m-0">
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5 p-0 border-right">
                <div className="payment-details">
                  <div className="detail-container">
                    <Loader width="250" height="15" />
                    <div className="amount">
                      <Loader width="350" height="30" />
                    </div>
                  </div>
                  <hr className="separator" />
                  <div className="detail-container">
                    <Loader width="350" height="30" />
                    <Loader width="350" height="50" />
                  </div>
                  <hr className="separator" />
                  <div className="detail-container">
                    <Loader width="250" height="15" />
                    <Loader width="350" height="50" />
                  </div>
                </div>
                {/* button */}
                <div className="footer">
                  {/* subtitute active class for disabled to either make button active or inactive */}
                  <button className="position-relative btn w-100 btn-primary-big btn-border-radius-payment active">
                    <Loader
                      width="350"
                      height="30"
                      pcolor="#2b9a36"
                      sec_color="#3cff51"
                    />
                  </button>
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7 p-0">
                <div className="payment-details">
                  <div className="row detail-container m-0">
                    <div className="col-lg-6 text">
                      {" "}
                      <Loader width="250" height="15" />
                    </div>
                    <div className="col-lg-6 text bold">
                      <Loader width="250" height="15" />
                    </div>
                  </div>
                  <hr className="separator" />
                  <div className="row detail-container m-0">
                    <div className="col-lg-6 text">
                      {" "}
                      <Loader width="250" height="15" />
                    </div>
                    <div className="col-lg-6 text bold">
                      {" "}
                      <Loader width="250" height="15" />
                    </div>
                  </div>
                  <hr className="separator" />
                  <div className="row detail-container m-0">
                    <div className="col-lg-6 text">
                      {" "}
                      <Loader width="250" height="15" />
                    </div>
                    <div className="col-lg-6 text bold">
                      {" "}
                      <Loader width="250" height="15" />
                    </div>
                  </div>
                  <hr className="separator" />
                  <div className="row detail-container m-0">
                    <div className="col-lg-6 text">
                      {" "}
                      <Loader width="250" height="15" />
                    </div>
                    <div className="col-lg-6 text bold">
                      <Loader width="250" height="15" />
                    </div>
                  </div>
                  <div className="row detail-container m-0">
                    <div className="col-lg-6 text-misc">
                      {" "}
                      <Loader width="250" height="15" />
                    </div>
                    <div className="col-lg-6 text-misc">
                      {" "}
                      <Loader width="250" height="15" />
                    </div>
                  </div>
                  <div className="row detail-container m-0">
                    <div className="col-lg-6 text-misc">
                      {" "}
                      <Loader width="250" height="15" />
                    </div>
                    <div className="col-lg-6 text-misc">
                      {" "}
                      <Loader width="250" height="15" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* card for outstanding fees */}
      </div>
    </div>
  </Fragment>
);

export default FeeDetailsLoader;
